import { render, staticRenderFns } from "./ChartOccupancy.vue?vue&type=template&id=b2589ab8"
import script from "./ChartOccupancy.vue?vue&type=script&lang=js"
export * from "./ChartOccupancy.vue?vue&type=script&lang=js"
import style0 from "./ChartOccupancy.vue?vue&type=style&index=0&id=b2589ab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports